// Utility functions for session storage
export const storeActivationCredentials = (email: string, password: string, cognitoId: string) => {
  try {
    sessionStorage.setItem('activationCredentials', JSON.stringify({ email, password, cognitoId }));
  } catch (error) {
    console.error('Failed to store credentials in sessionStorage:', error);
  }
};

export const getActivationCredentials = () => {
  try {
    const data = sessionStorage.getItem('activationCredentials');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Failed to retrieve credentials from sessionStorage:', error);
    return null;
  }
};

export const clearActivationCredentials = () => {
  sessionStorage.removeItem('activationCredentials');
};
